<div id="already-applied">
  <div *ngIf="! customMessage; else elseBlock" class="db-error-section">
    <p>{{'ERROR.FILLED_INFO_EXIST'|translate}}</p>
    <p *ngIf="isLanguageJapanese">{{'THANK_YOU'|translate}}</p>
  </div>
  <ng-template #elseBlock>
    <div [innerHTML]="(customMessage || '') | safeHtml" class="db-error-section">
      {{ customMessage }}
    </div>
  </ng-template>
</div>
